import { Component, Inject, OnInit, PLATFORM_ID, effect, inject, signal } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { Router, ActivatedRoute } from '@angular/router';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { AutoCompleteComponent } from '../../../../shared/components/auto-complete/auto-complete.component';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AutocompleteDirective } from '@shared/directives/autocomplete.directive';
import { DatepickerComponent } from '@shared/components/datepicker/datepicker.component';
import { DatepickerDirective } from '@shared/directives/datepicker.directive';
import { DatepickerService } from '@shared/services/datepicker.service';
import { SearchBoxService } from '@shared/services/serach-box.service';

export enum Tabs {
 hotel,
 ecolodge,
}

@Component({
 selector: 'iho-mobile-searchbox',
 templateUrl: './mobile-searchbox.component.html',
 styleUrls: ['./mobile-searchbox.component.scss'],
 providers: [],
 standalone: true,
 imports: [
  CommonModule,
  MatInputModule,
  MatTabsModule,
  MatFormFieldModule,
  MatButtonToggleModule,
  AutoCompleteComponent,
  AutocompleteDirective,
  DatepickerComponent,
  DatepickerDirective,
 ],
})
export class MobileSearchboxComponent {
 csrStatus = signal<any>(false);
 constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  effect(
   () => {
    if (this.datepickerService._state() && isPlatformBrowser(this.platformId)) {
     this.csrStatus.set(DatepickerComponent);
    }
   },
   { allowSignalWrites: true }
  );
 }

 /*
      - inject
    */
 router = inject(Router);
 route = inject(ActivatedRoute);
 autocompleteService = inject(AutocompleteService);
 datepickerService = inject(DatepickerService);
 searchBoxService = inject(SearchBoxService);
 toggle: boolean = true;

 /*
      - toggle
    */
 setToggle() {
  this.toggle = !this.toggle;
 }
 unfocus() {
  (document.querySelector('#autocompleteinput-plp') as any).blur();
  setTimeout(() => {
   (document.querySelectorAll('#autocompleteinput')[1] as any).focus();
  }, 100);
 }
 /*
      - search
    */
 search() {
  let parameters = {
   id: this.autocompleteService._selectedItem().id,
   type: this.autocompleteService._selectedItem().type,
   link: this.autocompleteService._selectedItem().link,
   name: this.autocompleteService._selectedItem().name,
   state: this.autocompleteService._selectedItem()?.state,
   startDate: this.datepickerService._startDate(),
   endDate: this.datepickerService._endDate(),
   isShabAdsCode: this.autocompleteService._selectedItem().isShabAdsCode,
  };

  this.searchBoxService.triggerSearch(parameters, false, this.autocompleteService.adCode());
 }

 changeAccommodation(accommodationType: string) {
  this.router.navigate([accommodationType == 'hotel' ? '/' : '/ecolodge']);
  this.searchBoxService.accommodation.set(accommodationType);
 }
}
